import { atomWithStorage } from "jotai/utils";

import { createCrossTabStorage } from "../store.utils";

export const currentWorkspaceIdAtom = atomWithStorage<string>(
  "workspaceId",
  "",
  createCrossTabStorage<string>()
);
